// Imports
import Alpine from 'alpinejs';
import Flickity from 'flickity';

class ClientFilters {
    constructor() {
        // Client-side filtering of result cards, no page reload or URL params
        // `labels` is a `{ filterKey: { slug: title } }` map, each card stores its
        // category slugs in a `data-*` attribute matching the filter key
        Alpine.data('clientFilters', (labels = {}) => {
            const FILTER_KEYS = Object.keys(labels);
            const empty = () => Object.fromEntries(FILTER_KEYS.map(key => [key, '']));

            // Kept outside of Alpine's reactive state
            let cards = [];

            return {
                labels: labels,
                filters: empty(),
                draft: empty(),
                count: 0,

                init() {
                    cards = Array.from(this.$el.querySelectorAll('[data-filter-item]'));

                    this.$watch('filters', () => this.apply(), { deep: true });
                    this.apply();
                },

                get isAll() {
                    return FILTER_KEYS.every(key => !this.filters[key]);
                },

                label(key, fallback) {
                    const slug = this.filters[key];
                    return (slug && this.labels[key]?.[slug]) || fallback;
                },

                setFilter(key, slug) {
                    this.filters[key] = slug;
                },

                clearFilters() {
                    FILTER_KEYS.forEach(key => {
                        this.filters[key] = '';
                        this.draft[key] = '';
                    });
                },

                // Mobile modal works on a draft that's committed on "Apply"
                openMobileFilters(filterId) {
                    this.draft = { ...this.filters };
                    this.$store.filters.openFilters(filterId);
                },

                applyDraft() {
                    this.filters = { ...this.draft };
                    this.$store.filters.closeFilters();
                },

                matches(card) {
                    return FILTER_KEYS.every(key => {
                        const slug = this.filters[key];
                        return !slug || (card.dataset[key] || '').split(' ').includes(slug);
                    });
                },

                apply() {
                    let count = 0;

                    cards.forEach(card => {
                        const visible = this.matches(card);
                        card.style.display = visible ? '' : 'none';

                        if (visible) {
                            count++;
                        }
                    });

                    this.count = count;

                    // Carousels initialised while hidden need resizing once visible
                    this.$nextTick(() => {
                        cards.forEach(card => {
                            card.querySelectorAll('.portfolio-carousel').forEach(carousel => {
                                Flickity.data(carousel)?.resize();
                            });
                        });
                    });
                },
            };
        });
    }
}

export default new ClientFilters();
